import Vue from 'vue';
import VueI18nFooter from 'vue-i18n';
import { Modal, Button, Collapse } from 'buefy';
import Printd from 'printd';
import 'buefy/dist/buefy.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faMinusSquare, faPlusSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

//
Vue.use(VueI18nFooter);
Vue.use(Modal); // Create VueI18n instance with options

const i18n = new VueI18nFooter({
  locale: 'en'
});
var script = {
  i18n: {
    locale: 'en',
    messages: {
      en: {
        faq: {
          faq_general: `
            <h2 class="is-size-4">General</h2>
            <h3 class="is-size-5">Why are certain industries named and grouped the way they are?</h3>
            <p>
              The information presented here is based on the most recent (2017) Canadian version of the 
              <a href="http://www.statcan.gc.ca/eng/subjects/standard/naics/2017v2/introduction" target="_blank">North American Industry Classification System</a>. We use the 
              standard titles, definitions, and examples provided in the <a href="http://www.statcan.gc.ca/eng/subjects/standard/naics/2017v2/introduction" target="_blank">NAICS handbook</a>.
            </p>
            <h3 class="is-size-5">Why can't I find information for my industry and/or location?</h3>
            <p>
              The information may not exist in the combination you've chosen. For example, poppy flowers are not endemic to Canada so poppy farming is not likely to yield 
              results in any province selected.
            </p>
            <p>
              Sometimes an industry is represented by such a small number of businesses in a certain location that we can't share the data without violating the privacy of 
              those businesses. Other times, the information may be inaccurate or missing. In these cases, Statistics Canada has flagged the data as unreliable and we have 
              removed it from our collection.
            </p>
            <h3 class="is-size-5">Why am I being shown a different industry and/or location than the one I chose?</h3>
            <p>
              We always show the most detailed and specific information available. However, if information is not available for your choices, the program will show the most 
              similar industry or location for which information is available.
            </p>
            <p>
              In the case of location, this often means showing you national instead of provincial information.
            </p>
            <p>
              In the case of industry, this often means showing you information from a broader sector instead of the specific industry you chose. For example, we may not 
              have information on resorts in particular but we have information on the traveller accommodation sector (which includes resorts, hotels, motels, and motor 
              homes).
            </p>`,
          print_text: "Print",
          close_text: "Close"
        }
      },
      fr: {
        faq: {
          faq_general: `
            <h2 class="is-size-4">Générale</h2>
            <h3 class="is-size-5">Pourquoi certaines industries sont nommées et groupées de cette façon?</h3>
            <p>
              L'information présenté ici est basé sur la version canadienne la plus récente (2017) du 
              <a href="https://www.statcan.gc.ca/fra/sujets/norme/scian/2017v2/introduction" target="_blank">Système de classification des industries de l'Amérique du Nord</a>. 
              Nous utilisons les titres, les définitions et les exemples standards fourni dans le 
              <a href="https://www.statcan.gc.ca/fra/sujets/norme/scian/2017v2/introduction" target="_blank">guide du SCIAN</a>.
            </p>
            <h3 class="is-size-5">Pourquoi je ne peux trouver l'information pour mon industrie et/ou l'emplacement?</h3>
            <p>
              L'information peut ne pas existé dans la combinaison que vous avez choisi. Par exemple, le coquelicot n'est pas une espèce endémique du Canada donc l'agriculture 
              du coquelicot ne produirait probablement pas des résultats dans l'une ou l'autre des provinces sélectionnées.
            </p>
            <p>
              Parfois une industrie est représenté par un faible nombre d'entreprises dans un certain emplacement que nous ne pouvons pas partager les données sans 
              faire abstraction à la protection de la vie privée de ses entrprises. En d'autre temps, l'information peut être inexacte ou manquant. Dans ces cas, Statistique 
              Canada a signalé les données comme un fonctionnement incertain et nous les avons retiré de notre collection.
            </p>
            <h3 class="is-size-5">Pourquoi je suis montré une industrie et/ou emplacement différent de ce que j'ai choisi?</h3>
            <p>
              Nous montrons toujours l'information la plus détaillé et spécifique disponible. Cependant, si l'information n'est pas disponible pour vos choix, le programme va 
              montrer l'industrie ou l'emplacement le plus similaire dont l'information est disponible.
            </p>
            <p>
              Dans le cas de l'emplacement, ceci veut souvent dire qu'on vous montre l'information national au lieu de provincial.
            </p>
            <p>
              Dans le cas de l'industrie, ceci veut souvent dire qu'on vous montre l'information à partir d'un secteur plus générale au lieu d'une industrie 
              spécifique que vous avez choisi. Par exemple, nous n'avons peut-être pas l'information sur les centres de villégiature en particulier mais nous avons 
              l'information sur le secteur de l'hébergement des voyageurs (qui inclus centres de villégiature, hôtels, motels et maisons motorisées).
            </p>`,
          print_text: "Imprimer",
          close_text: "Fermer"
        }
      }
    }
  },
  // end i18n
  props: ['lang'],
  mounted: function () {
    this.$i18n.locale = this.toggleLang;
  },
  computed: {
    toggleLang: function () {
      return this.lang;
    }
  },
  // end computed
  methods: {
    print: function () {
      const d = new Printd();
      d.print(this.$refs.PrintBody);
    }
  } // end methods

};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('section', [_c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "id": "general"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    ref: "PrintBody",
    staticClass: "modal-card-body footerSourceModal",
    attrs: {
      "id": "printBody"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('faq.faq_general'))
    }
  })]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot footerSourceModal-foot"
  }, [_c('b-button', {
    staticClass: "button",
    on: {
      "click": function ($event) {
        return _vm.print();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('faq.print_text')))]), _vm._v(" "), _c('b-button', {
    staticClass: "button",
    on: {
      "click": function ($event) {
        return _vm.$parent.close();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('faq.close_text')))])], 1)])]);
};

var __vue_staticRenderFns__ = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('header', {
    staticClass: "modal-card-head footerSourceModal-head"
  }, [_c('p', {
    staticClass: "modal-card-title footerSourceModal-title"
  }, [_vm._v("FAQ")])]);
}];
/* style */

const __vue_inject_styles__ = undefined;
/* scoped */

const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

//
Vue.use(VueI18nFooter);
Vue.use(Modal); // Create VueI18n instance with options

const i18n$1 = new VueI18nFooter({
  locale: 'en'
});
var script$1 = {
  i18n: {
    locale: 'en',
    messages: {
      en: {
        faq: {
          faq_fp: `
            <h2 class="is-size-4">Financial Performance Data</h2>
            <h3 class="is-size-5">Where did you get this information from?</h3>
            <p>
              We downloaded the raw data from the <a href="https://open.canada.ca/data/en/dataset/f559526c-40f9-4c5d-bced-0f7a41f278b9" target="_blank">Government of Canada 
              Open Data Portal</a>, which is publicly available. This program contains information licensed under the 
              <a href="https://open.canada.ca/en/open-government-licence-canada" target="_blank">Open Government Licence - Canada</a>.
            </p>
            <h3 class="is-size-5">How can I access this information in a different format?</h3>
            <p>
              You can download the raw data in another format from the <a href="https://open.canada.ca/data/en/dataset/f559526c-40f9-4c5d-bced-0f7a41f278b9" target="_blank">Government of Canada Open Data Portal</a>, 
              which is publicly available. This program contains information licensed under the <a href="https://open.canada.ca/en/open-government-licence-canada" target="_blank">Open Government Licence – Canada</a>.
            </p>
            <h3 class="is-size-5">How was this information collected?</h3>
            <p>
              Financial Performance Data is based on tax return information from all businesses in Canada reporting annual revenue of between $30,000 to $5 million. Because 
              information is collected from all businesses (i.e. a "census"), there are no sampling techniques being used.
            </p>
            <h3 class="is-size-5">How many people provided information?</h3>
            <p>
              Information was provided by the total population of businesses. The exact number depends on how many businesses exist in your chosen region and industry.
            </p>
            <h3 class="is-size-5">How often is this updated?</h3>
            <p>
              The most current information we have is for 2015. You can get the raw data for more recent year directly from the 
              <a href="https://open.canada.ca/data/en/dataset?portal_type=dataset&q=Financial+Performance+Data" target="_blank">Government of Canada Open Data Portal</a>, 
              which is publicly available.
            </p>
            <h3 class="is-size-5">I'm not sure what a term (for example: 'profitable business') means.</h3>
            <p>
              Please see the <a href="https://www.ic.gc.ca/eic/site/pp-pp.nsf/eng/h_pm00003.html" target="_blank">Financial Performance Data glossary</a> for definitions of 
              the terms used.
            </p>
            <h3 class="is-size-5">What is the difference between what I see here and what is available on the Financial Performance Data website?</h3>
            <p>
              We present information in a visual way that is quick and easy to understand. We also allow for easy comparisons between locations and/or industries.
            </p>
            <p>
              However, we only present some of the information that is available. If you are looking for more detailed information (such as breakdowns by quartiles), the 
              <a href="https://www.ic.gc.ca/eic/site/pp-pp.nsf/eng/home" target="_blank">Financial Performance Data website</a> and 
              <a href="https://open.canada.ca/data/en/dataset?portal_type=dataset&q=Financial+Performance+Data" target="_blank">Open Data</a> are better choices.
            </p>
            <h3 class="is-size-5">Why can't I find information on other financial performance measures, like debt to equity ratio?</h3>
            <p>
              We are constantly seeking to grow and improve our products. If you have a suggestion for a new type of information you'd like to see, feel free to contact us 
              with your ideas.
            </p>`,
          faq_general: `
            <h2 class="is-size-4">General</h2>
            <h3 class="is-size-5">Why are certain industries named and grouped the way they are?</h3>
            <p>
              The information presented here is based on the most recent (2017) Canadian version of the 
              <a href="http://www.statcan.gc.ca/eng/subjects/standard/naics/2017v2/introduction" target="_blank">North American Industry Classification System</a>. We use the 
              standard titles, definitions, and examples provided in the <a href="http://www.statcan.gc.ca/eng/subjects/standard/naics/2017v2/introduction" target="_blank">NAICS handbook</a>.
            </p>
            <h3 class="is-size-5">Why can't I find information for my industry and/or location?</h3>
            <p>
              The information may not exist in the combination you've chosen. For example, poppy flowers are not endemic to Canada so poppy farming is not likely to yield 
              results in any province selected.
            </p>
            <p>
              Sometimes an industry is represented by such a small number of businesses in a certain location that we can't share the data without violating the privacy of 
              those businesses. Other times, the information may be inaccurate or missing. In these cases, Statistics Canada has flagged the data as unreliable and we have 
              removed it from our collection.
            </p>
            <h3 class="is-size-5">Why am I being shown a different industry and/or location than the one I chose?</h3>
            <p>
              We always show the most detailed and specific information available. However, if information is not available for your choices, the program will show the most 
              similar industry or location for which information is available.
            </p>
            <p>
              In the case of location, this often means showing you national instead of provincial information.
            </p>
            <p>
              In the case of industry, this often means showing you information from a broader sector instead of the specific industry you chose. For example, we may not 
              have information on resorts in particular but we have information on the traveller accommodation sector (which includes resorts, hotels, motels, and motor 
              homes).
            </p>`,
          print_text: "Print",
          close_text: "Close"
        }
      },
      fr: {
        faq: {
          faq_fp: `
            <h2 class="is-size-4">Données sur la performance financière</h2>
            <h3 class="is-size-5">Où avez-vous obtenu cette information?</h3>
            <p>
              Nous avons téléchargé les données brutes du <a href="https://ouvert.canada.ca/data/fr/dataset/f559526c-40f9-4c5d-bced-0f7a41f278b9" target="_blank">Portal de 
              données ouvert du Gouvernement du Canada</a>, qui est accessible à tous. Ce programme contient de l'information sous la 
              <a href="https://ouvert.canada.ca/fr/licence-du-gouvernement-ouvert-canada" target="_blank">Licence du gouvernement ouvert - Canada</a>.
            </p>
            <h3 class="is-size-5">Comment je peux obtenir cette information sous un autre format?</h3>
            <p>
              Vous pouvez télécharger les données brutes dans un autre format directement à partir du site Web 
              <a href="https://ouvert.canada.ca/data/fr/dataset/f559526c-40f9-4c5d-bced-0f7a41f278b9" target="_blank">Portal de données ouvert du Gouvernement du Canada</a>, 
              qui est accessible à tous. Ce programme contient de l'information sous la 
              <a href="https://ouvert.canada.ca/fr/licence-du-gouvernement-ouvert-canada" target="_blank">Licence du gouvernement ouvert - Canada</a>.
            </p>
            <h3 class="is-size-5">Comment l'information a-t-elle été collecté?</h3>
            <p>
              Les Données sur la performance financière sont basés sur l'information des déclarations de revenus de toutes entreprises au Canada ayant un revenu annuel entre 
              30&nbsp;000&nbsp;$ à 5&nbsp;millions. Parceque l'information est collecté de toutes les entreprises (ex. : un recensement), il n'y a pas de techniques 
              d'échantillonnage qui sont utilisés.
            </p>
            <h3 class="is-size-5">Combien de personnes ont fourni de l'information?</h3>
            <p>
              L'information a été fourni par la population d'entreprises total. Le nombre exact dépend sur combien d'entreprises qui existent dans votre région et industrie 
              que vous avez choisi.
            </p>
            <h3 class="is-size-5">Quelle est la fréquence de mise à jour des données?</h3>
            <p>
              L'information la plus courante que nous avons est pour 2015. Vous pouvez obtenir les données brutes pour des années plus récentes directement du site Web 
              <a href="https://ouvert.canada.ca/data/fr/dataset?q=Donn%C3%A9es+sur+la+performance+financi%C3%A8re" target="_blank">Portal de données ouvert du Gouvernement du 
              Canada</a>, qui est accessible à tous.
            </p>
            <h3 class="is-size-5">Je ne suis pas certain ce qu'un terme (par exemple : 'entreprises rentables') veut dire.</h3>
            <p>
              Veuillez consulter <a href="https://www.ic.gc.ca/eic/site/pp-pp.nsf/fra/h_pm00003.html" target="_blank">Glossaire de Données sur la performance financière</a> 
              pour les définitions des termes utilisés.
            </p>
            <h3 class="is-size-5">Qu'elle est la difference entre ce quoi je trouve ici et ce qui est disponible sur le site Web Données sur la performance financière?</h3>
            <p>
              Nous présentons l'information dans un visuel qui est vite et facile à comprendre. Nous permettons aussi des comparaisons facile entre emplacements et/ou industries.
            </p>
            <p>
              Cependant, nous présentons seulement certaine information qui sont disponible. Si vous cherchez pour de l'information plus détaillée (comme des analyses par 
              quarts), le site Web <a href="https://www.ic.gc.ca/eic/site/pp-pp.nsf/fra/accueil" target="_blank">Données sur la performance financière</a> et 
              <a href="https://ouvert.canada.ca/data/fr/dataset?q=Donn%C3%A9es+sur+la+performance+financi%C3%A8re" target="_blank">Données ouvertes</a> sont des meilleurs choix.
            </p>
            <h3 class="is-size-5">Pourquoi je ne peux trouver de l'information sur les autres mesures du rendement financier, comme le ratio d'endettement passif-avoir?</h3>
            <p>
              Nous sommes constament à la recherche de développer et d'améliorer nos produits. Si vous avez une suggestion pour un nouveau type d'information que vous voulez 
              voir, n'hésitez pas à nous contacter avec vos idées.
            </p>`,
          faq_general: `
            <h2 class="is-size-4">Générale</h2>
            <h3 class="is-size-5">Pourquoi certaines industries sont nommées et groupées de cette façon?</h3>
            <p>
              L'information présenté ici est basé sur la version canadienne la plus récente (2017) du 
              <a href="https://www.statcan.gc.ca/fra/sujets/norme/scian/2017v2/introduction" target="_blank">Système de classification des industries de l'Amérique du Nord</a>. 
              Nous utilisons les titres, les définitions et les exemples standards fourni dans le 
              <a href="https://www.statcan.gc.ca/fra/sujets/norme/scian/2017v2/introduction" target="_blank">guide du SCIAN</a>.
            </p>
            <h3 class="is-size-5">Pourquoi je ne peux trouver l'information pour mon industrie et/ou l'emplacement?</h3>
            <p>
              L'information peut ne pas existé dans la combinaison que vous avez choisi. Par exemple, le coquelicot n'est pas une espèce endémique du Canada donc l'agriculture 
              du coquelicot ne produirait probablement pas des résultats dans l'une ou l'autre des provinces sélectionnées.
            </p>
            <p>
              Parfois une industrie est représenté par un faible nombre d'entreprises dans un certain emplacement que nous ne pouvons pas partager les données sans 
              faire abstraction à la protection de la vie privée de ses entrprises. En d'autre temps, l'information peut être inexacte ou manquant. Dans ces cas, Statistique 
              Canada a signalé les données comme un fonctionnement incertain et nous les avons retiré de notre collection.
            </p>
            <h3 class="is-size-5">Pourquoi je suis montré une industrie et/ou emplacement différent de ce que j'ai choisi?</h3>
            <p>
              Nous montrons toujours l'information la plus détaillé et spécifique disponible. Cependant, si l'information n'est pas disponible pour vos choix, le programme va 
              montrer lindustrie ou l'emplacement le plus similaire dont l'information est disponible.
            </p>
            <p>
              Dans le cas de l'emplacement, ceci veut souvent dire qu'on vous montre l'information national au lieu de provincial.
            </p>
            <p>
              Dans le cas de l'industrie, ceci veut souvent dire qu'on vous montre l'information à partir d'un secteur plus générale au lieu d'une industrie 
              spécifique que vous avez choisi. Par exemple, nous n'avons peut-être pas l'information sur les centres de villégiature en particulier mais nous avons 
              l'information sur le secteur de l'hébergement des voyageurs (qui inclus centres de villégiature, hôtels, motels et maisons motorisées).
            </p>`,
          print_text: "Imprimer",
          close_text: "Fermer"
        }
      }
    }
  },
  // end i18n
  props: ['lang'],
  mounted: function () {
    this.$i18n.locale = this.toggleLang;
  },
  computed: {
    toggleLang: function () {
      return this.lang;
    }
  },
  // end computed
  methods: {
    print: function () {
      const d = new Printd();
      d.print(this.$refs.PrintBody);
    }
  } // end methods

};

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('section', [_c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "id": "fp"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    ref: "PrintBody",
    staticClass: "modal-card-body footerSourceModal",
    attrs: {
      "id": "PrintBody"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('faq.faq_fp'))
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('faq.faq_general'))
    }
  })]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot footerSourceModal-foot"
  }, [_c('b-button', {
    staticClass: "button",
    on: {
      "click": function ($event) {
        return _vm.print();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('faq.print_text')))]), _vm._v(" "), _c('b-button', {
    staticClass: "button",
    on: {
      "click": function ($event) {
        return _vm.$parent.close();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('faq.close_text')))])], 1)])]);
};

var __vue_staticRenderFns__$1 = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('header', {
    staticClass: "modal-card-head footerSourceModal-head"
  }, [_c('p', {
    staticClass: "modal-card-title footerSourceModal-title"
  }, [_vm._v("FAQ")])]);
}];
/* style */

const __vue_inject_styles__$1 = undefined;
/* scoped */

const __vue_scope_id__$1 = undefined;
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

//
Vue.use(VueI18nFooter);
Vue.use(Modal); // Create VueI18n instance with options

const i18n$2 = new VueI18nFooter({
  locale: 'en'
});
var script$2 = {
  i18n: {
    locale: 'en',
    messages: {
      en: {
        faq: {
          faq_pop: `
            <h2 class="is-size-4">Population, by Gender and Age</h2>
            <h3 class="is-size-5">Where did you get this information from?</h3>
            <p>
              We downloaded data tables directly from Statistics Canada's Census program, which is publicly available.
            </p>
            <h3 class="is-size-5">How can I access this information in a different format?</h3>
            <p>
              You can interact with the dataset in real time at the corresponding Data Tables, 2016 page. There, you can also download the file in a CSV, TAB, IVT (Beyond 20/20), 
              or XML format.
            </p>
            <h3 class="is-size-5">How often is this information updated?</h3>
            <p>
              The most current information we have is for 2016. The next census will be held in May 2021 and information will be available shortly thereafter.
            </p>
            <h3 class="is-size-5">How many people provided information?</h3>
            <p>
              Respondents are required by law to complete their census questionnaire, making it an extraordinarily thorough and robust product. Information was provided by the 
              total population of Canada.
            </p>
            <h3 class="is-size-5">What about sampling bias?</h3>
            <p>
              Because information is collected from all citizens, there are no sampling techniques being used.
            </p>
            <h3 class="is-size-5">What is the difference between what I see here and what is available from the Statistics Canada Data Tables?</h3>
            <p>
              We present complex information in a visual way that is quick and easy to understand. We also allow for easy comparisons between cities.
            </p>
            <p>
              However, we only present some of the information that is available. If you are looking for more detailed information (such as a breakdown by each individual year 
              of age), please consult the original Statistics Canada Data Tables.
            </p>
            <h3 class="is-size-5">Why can't I find information on other population characteristics, like ethnic diversity or income?</h3>
            <p>
              We are constantly seeking to grow and improve our products. If you have a suggestion for a new type of information you'd like to see, feel free to contact us 
              with your ideas.
            </p>`,
          faq_general: `
            <h2 class="is-size-4">General</h2>
            <h3 class="is-size-5">Why are certain industries named and grouped the way they are?</h3>
            <p>
              The information presented here is based on the most recent (2017) Canadian version of the 
              <a href="http://www.statcan.gc.ca/eng/subjects/standard/naics/2017v2/introduction" target="_blank">North American Industry Classification System</a>. We use the 
              standard titles, definitions, and examples provided in the <a href="http://www.statcan.gc.ca/eng/subjects/standard/naics/2017v2/introduction" target="_blank">NAICS handbook</a>.
            </p>
            <h3 class="is-size-5">Why can't I find information for my industry and/or location?</h3>
            <p>
              The information may not exist in the combination you've chosen. For example, poppy flowers are not endemic to Canada so poppy farming is not likely to yield 
              results in any province selected.
            </p>
            <p>
              Sometimes an industry is represented by such a small number of businesses in a certain location that we can't share the data without violating the privacy of 
              those businesses. Other times, the information may be inaccurate or missing. In these cases, Statistics Canada has flagged the data as unreliable and we have 
              removed it from our collection.
            </p>
            <h3 class="is-size-5">Why am I being shown a different industry and/or location than the one I chose?</h3>
            <p>
              We always show the most detailed and specific information available. However, if information is not available for your choices, the program will show the most 
              similar industry or location for which information is available.
            </p>
            <p>
              In the case of location, this often means showing you national instead of provincial information.
            </p>
            <p>
              In the case of industry, this often means showing you information from a broader sector instead of the specific industry you chose. For example, we may not 
              have information on resorts in particular but we have information on the traveller accommodation sector (which includes resorts, hotels, motels, and motor 
              homes).
            </p>`,
          print_text: "Print",
          close_text: "Close"
        }
      },
      fr: {
        faq: {
          faq_pop: `
            <h2 class="is-size-4">Population, par sexe et âge</h2>
            <h3 class="is-size-5">Où avez-vous obtenu l'information?</h3>
            <p>
              Nous avons téléchargé les tableaux de données directement du programme de recensement de Statistique Canada, qui est disponible publiquement.
            </p>
            <h3 class="is-size-5">Comment puis-je accéder à cette information dans un format différent?</h3>
            <p>
              Vous pouvez interagir avec l'ensemble de données en temps réel à la page correspondante des tableaux de données de 2016. À cet endroit, vous pouvez aussi 
              télécharger un fichier dans un format CSV, TAB, IVT (Beyond 20/20) ou XML.
            </p>
            <h3 class="is-size-5">À quelle fréquence l'information est-elle mise à jour?</h3>
            <p>
              L'information la plus courante que nous avons est pour 2016. Le prochain recencement va être tenu en mai 2021 et l'information va être disponible peu de temps 
              après.
            </p>
            <h3 class="is-size-5">Combien de personne ont fourni de l'information?</h3>
            <p>
              Les répondants sont requis par la loi de compléter leur questionnaire du recencement, le fesant un produit extraordinairement complet et robuste. L'information a 
              été fourni par toute la population du Canada.
            </p>
            <h3 class="is-size-5">Que dites-vous du biais d'échantillonnage?</h3>
            <p>
              Parce que l'information est récolté par tous les citoyens, il n'y a pas de technique d'échantillonage qui est utilisé.
            </p>
            <h3 class="is-size-5">Quelle est la différence entre ce que je vois ici et ce qui est disponible par les tableaux de données de Statistique Canada?</h3>
            <p>
              Nous présentons l'information complexe dans une façon visuelle qui est vite et facile à comprendre. Nous permettons aussi des comparaisons faciles entre les villes.
            </p>
            <p>
              Cependant, nous présentons seulement quelque information qui est disponible. Si vous cherchez pour de l'information plus détaillée (tel qu'une décomposition par 
              chaque année d'âge), veuillez consulter les tableaux de données originaux de Statistique Canada.
            </p>
            <h3 class="is-size-5">Pourquoi je ne peux trouver de l'information sur les autres caractéristiques de la population, comme la diversité ethnique ou le revenu?</h3>
            <p>
              Nous cherchons constament à développer et à améliorer nos produits. Si vous avez une suggestion pour un nouveau type d'information que vous voulez voir, 
              contactez nous avec vos idées.
            </p>`,
          faq_general: `
            <h2 class="is-size-4">Générale</h2>
            <h3 class="is-size-5">Pourquoi certaines industries sont nommées et groupées de cette façon?</h3>
            <p>
              L'information présenté ici est basé sur la version canadienne la plus récente (2017) du 
              <a href="https://www.statcan.gc.ca/fra/sujets/norme/scian/2017v2/introduction" target="_blank">Système de classification des industries de l'Amérique du Nord</a>. 
              Nous utilisons les titres, les définitions et les exemples standards fourni dans le 
              <a href="https://www.statcan.gc.ca/fra/sujets/norme/scian/2017v2/introduction" target="_blank">guide du SCIAN</a>.
            </p>
            <h3 class="is-size-5">Pourquoi je ne peux trouver l'information pour mon industrie et/ou l'emplacement?</h3>
            <p>
              L'information peut ne pas existé dans la combinaison que vous avez choisi. Par exemple, le coquelicot n'est pas une espèce endémique du Canada donc l'agriculture 
              du coquelicot ne produirait probablement pas des résultats dans l'une ou l'autre des provinces sélectionnées.
            </p>
            <p>
              Parfois une industrie est représenté par un faible nombre d'entreprises dans un certain emplacement que nous ne pouvons pas partager les données sans 
              faire abstraction à la protection de la vie privée de ses entrprises. En d'autre temps, l'information peut être inexacte ou manquant. Dans ces cas, Statistique 
              Canada a signalé les données comme un fonctionnement incertain et nous les avons retiré de notre collection.
            </p>
            <h3 class="is-size-5">Pourquoi je suis montré une industrie et/ou emplacement différent de ce que j'ai choisi?</h3>
            <p>
              Nous montrons toujours l'information la plus détaillé et spécifique disponible. Cependant, si l'information n'est pas disponible pour vos choix, le programme va 
              montrer l'industrie ou l'emplacement le plus similaire dont l'information est disponible.
            </p>
            <p>
              Dans le cas de l'emplacement, ceci veut souvent dire qu'on vous montre l'information national au lieu de provincial.
            </p>
            <p>
              Dans le cas de l'industrie, ceci veut souvent dire qu'on vous montre l'information à partir d'un secteur plus générale au lieu d'une industrie 
              spécifique que vous avez choisi. Par exemple, nous n'avons peut-être pas l'information sur les centres de villégiature en particulier mais nous avons 
              l'information sur le secteur de l'hébergement des voyageurs (qui inclus centres de villégiature, hôtels, motels et maisons motorisées).
            </p>`,
          print_text: "Imprimer",
          close_text: "Fermer"
        }
      }
    }
  },
  // end i18n
  props: ['lang'],
  mounted: function () {
    this.$i18n.locale = this.toggleLang;
  },
  computed: {
    toggleLang: function () {
      return this.lang;
    }
  },
  // end computed
  methods: {
    print: function () {
      const d = new Printd();
      d.print(this.$refs.PrintBody);
    }
  } // end methods

};

/* script */
const __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('section', [_c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "id": "pop"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    ref: "PrintBody",
    staticClass: "modal-card-body footerSourceModal",
    attrs: {
      "id": "printBody"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('faq.faq_pop'))
    }
  })]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot footerSourceModal-foot"
  }, [_c('b-button', {
    staticClass: "button",
    on: {
      "click": function ($event) {
        return _vm.print();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('faq.print_text')))]), _vm._v(" "), _c('b-button', {
    staticClass: "button",
    on: {
      "click": function ($event) {
        return _vm.$parent.close();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('faq.close_text')))])], 1)])]);
};

var __vue_staticRenderFns__$2 = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('header', {
    staticClass: "modal-card-head footerSourceModal-head"
  }, [_c('p', {
    staticClass: "modal-card-title footerSourceModal-title"
  }, [_vm._v("FAQ")])]);
}];
/* style */

const __vue_inject_styles__$2 = undefined;
/* scoped */

const __vue_scope_id__$2 = undefined;
/* module identifier */

const __vue_module_identifier__$2 = undefined;
/* functional template */

const __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

//
Vue.use(VueI18nFooter);
Vue.use(Modal);
Vue.use(Button); // Create VueI18n instance with options

const i18n$3 = new VueI18nFooter({
  locale: 'en'
});
var script$3 = {
  i18n: {
    locale: 'en',
    messages: {
      en: {
        faq: {
          faq_general: `
            <h2 class="is-size-4">General</h2>
            <h3 class="is-size-5">Why are certain industries named and grouped the way they are?</h3>
            <p>
              The information presented here is based on the most recent (2017) Canadian version of the 
              <a href="http://www.statcan.gc.ca/eng/subjects/standard/naics/2017v2/introduction" target="_blank">North American Industry Classification System</a>. We use the 
              standard titles, definitions, and examples provided in the <a href="http://www.statcan.gc.ca/eng/subjects/standard/naics/2017v2/introduction" target="_blank">NAICS handbook</a>.
            </p>
            <h3 class="is-size-5">Why can't I find information for my industry and/or location?</h3>
            <p>
              The information may not exist in the combination you've chosen. For example, poppy flowers are not endemic to Canada so poppy farming is not likely to yield 
              results in any province selected.
            </p>
            <p>
              Sometimes an industry is represented by such a small number of businesses in a certain location that we can't share the data without violating the privacy of 
              those businesses. Other times, the information may be inaccurate or missing. In these cases, Statistics Canada has flagged the data as unreliable and we have 
              removed it from our collection.
            </p>
            <h3 class="is-size-5">Why am I being shown a different industry and/or location than the one I chose?</h3>
            <p>
              We always show the most detailed and specific information available. However, if information is not available for your choices, the program will show the most 
              similar industry or location for which information is available.
            </p>
            <p>
              In the case of location, this often means showing you national instead of provincial information.
            </p>
            <p>
              In the case of industry, this often means showing you information from a broader sector instead of the specific industry you chose. For example, we may not 
              have information on resorts in particular but we have information on the traveller accommodation sector (which includes resorts, hotels, motels, and motor 
              homes).
            </p>`,
          faq_wage: `
            <h2 class="is-size-4">Median Hourly Full-time Wage</h2>
            <h3 class="is-size-5">What is the wage data for?</h3>
            <p>
              The wage data widget is intended to provide insight into the hourly wage for a given occupation within economic regions of Canada. The dataset we use is 
              prepared by the Labour Market Data, Methods and Analysis Division of Employment and Social Development Canada (ESDC) and it is used in the trends and analysis 
              section of the Government of Canada’s <a href="https://www.jobbank.gc.ca/trend-analysis" target="_blank">Job Bank website</a>.
            </p>
            <p>
              The median is used for hourly wage for an occupation. The median wage is preferred over the average wage because it is less sensitive to extreme values and 
              more representative of the typical worker's salary.
            </p>
            <p>
              Occupations are classified using the National Occupation Classification system at the four-digit level.
            </p>
            <p>
              Location data is presented by the Economic Region, a variant of the Standard Geographical Region statistical classification system created by Statistics Canada 
              as a standard geographic unit for the analysis of economic activity within 76 regions across Canada. In our widget, each location is linked to its respective 
              economic region.
            </p>
            <h3 class="is-size-5">Which sources of data are used?</h3>
            <p>
              Wages are determined using a joint <abbr title="Employment and Social Development Canada">ESDC</abbr> and Statistics Canada methodology. 
              <abbr title="Employment and Social Development Canada">ESDC</abbr> consults other stakeholders during the validation process, such as provincial and territorial 
              governments, other federal departments and external organizations.
            </p>
            <p>
              As the primary source of the dataset, <abbr title="Employment and Social Development Canada">ESDC</abbr> uses Statistics Canada's Labour Force Survey:
            </p>
            <ul>
              <li>the most inclusive, timely and unbiased source of wage data by occupational group</li>
              <li>this survey is conducted using a sample of respondents</li>
              <li>data may be suppressed for reasons of confidentiality or data quality</li>
            </ul>
            <p>
              When the Labour Force Survey data are not available, other sources are considered, including:
            </p>
            <ul>
              <li><abbr title="Employment and Social Development Canada">ESDC</abbr> program data such as Employment Insurance program survey data</li>
              <li>the Census</li>
              <li>provincial and territorial surveys and administrative data</li>
              <li>other organizations administrative data</li>
            </ul>
            <p>
              For the complete process followed by <abbr title="Employment and Social Development Canada">ESDC</abbr>, please see their 
              <a href="https://www.jobbank.gc.ca/trend-analysis/search-wages/wage-methodology" target="_blank">Wage Methodology</a>.
            </p>
            <h3 class="is-size-5">Have you manipulated the original dataset?</h3>
            <p>
              We have removed from the dataset salaries that were presented as an annual salary versus an hourly wage. However, this data can be found from the original source.
            </p>
            <h3 class="is-size-5">Why is there no data available for some combinations of occupation and location?</h3>
            <p>
              It is not always possible to determine occupational wages for all economic regions due to data limitations (suppression of data due to low quality and privacy 
              reasons). When this is the case, we will display the minimum wage of the province or territory. When comparing locations or industries, these values will appear 
              as not available (n/a) and without the minimum wage.
            </p>
            <h3 class="is-size-5">How are you able to pull occupational data by searching for an industry?</h3>
            <p>
              We have done an extensive analysis to develop a mapping of occupations by industries. Through concordance tables, we are able to link wage data by occupation to 
              their related industries.
            </p>
            <h3 class="is-size-5">Which datasets is used by the widget?</h3>
            <p>
              Our widget is using the <abbr title="Employment and Social Development Canada">ESDC</abbr> 2019 Wages Dataset, which can be downloaded from the Government of Canada's <a href="https://open.canada.ca/data/en/dataset/adad580f-76b0-4502-bd05-20c125de9116" target="_blank">Open Data website</a>.
            </p>
            <h3 class="is-size-5">How soon is the widget updated after a new wage data version is released?</h3>
            <p>
              We aim to update the data within 3 months of the new release of new dataset. This dataset is produced yearly, and it is published in the late fall.
            </p>
            <h3 class="is-size-5">Attribution statement</h3>
            <p> 
              Contains information licensed under the <a href="https://open.canada.ca/en/open-government-licence-canada" target="_blank">Open Government Licence – Canada</a>
            </p>`,
          print_text: "Print",
          close_text: "Close"
        }
      },
      fr: {
        faq: {
          faq_general: `
            <h2 class="is-size-4">Générale</h2>
            <h3 class="is-size-5">Pourquoi certaines industries sont nommées et groupées de cette façon?</h3>
            <p>
              L'information présenté ici est basé sur la version canadienne la plus récente (2017) du 
              <a href="https://www.statcan.gc.ca/fra/sujets/norme/scian/2017v2/introduction" target="_blank">Système de classification des industries de l'Amérique du Nord</a>. 
              Nous utilisons les titres, les définitions et les exemples standards fourni dans le 
              <a href="https://www.statcan.gc.ca/fra/sujets/norme/scian/2017v2/introduction" target="_blank">guide du SCIAN</a>.
            </p>
            <h3 class="is-size-5">Pourquoi je ne peux trouver l'information pour mon industrie et/ou l'emplacement?</h3>
            <p>
              L'information peut ne pas existé dans la combinaison que vous avez choisi. Par exemple, le coquelicot n'est pas une espèce endémique du Canada donc l'agriculture 
              du coquelicot ne produirait probablement pas des résultats dans l'une ou l'autre des provinces sélectionnées.
            </p>
            <p>
              Parfois une industrie est représenté par un faible nombre d'entreprises dans un certain emplacement que nous ne pouvons pas partager les données sans 
              faire abstraction à la protection de la vie privée de ses entrprises. En d'autre temps, l'information peut être inexacte ou manquant. Dans ces cas, Statistique 
              Canada a signalé les données comme un fonctionnement incertain et nous les avons retiré de notre collection.
            </p>
            <h3 class="is-size-5">Pourquoi je suis montré une industrie et/ou emplacement différent de ce que j'ai choisi?</h3>
            <p>
              Nous montrons toujours l'information la plus détaillé et spécifique disponible. Cependant, si l'information n'est pas disponible pour vos choix, le programme va 
              montrer l'industrie ou l'emplacement le plus similaire dont l'information est disponible.
            </p>
            <p>
              Dans le cas de l'emplacement, ceci veut souvent dire qu'on vous montre l'information national au lieu de provincial.
            </p>
            <p>
              Dans le cas de l'industrie, ceci veut souvent dire qu'on vous montre l'information à partir d'un secteur plus générale au lieu d'une industrie 
              spécifique que vous avez choisi. Par exemple, nous n'avons peut-être pas l'information sur les centres de villégiature en particulier mais nous avons 
              l'information sur le secteur de l'hébergement des voyageurs (qui inclus centres de villégiature, hôtels, motels et maisons motorisées).
            </p>`,
          faq_wage: `
            <h2 class="is-size-4">Salaire horaire médian à temps plein</h2>
            <h3 class="is-size-5">Quelle est l'utilité des données sur les salaires?</h3>
            <p>
              Le widget de données sur les salaires vise à donner un aperçu du salaire horaire pour une profession donnée dans les régions économiques du Canada.
            </p>
            <p>
              Le jeu de données que nous utilisons est préparé par la Division des données, Méthodes et analyse du marché du travail d'Emploi et Développement social Canada (EDSC) 
              où il est utilisé dans la section d'analyse des tendances du <a href="https://www.guichetemplois.gc.ca/analyse-tendances" target="_blank">site Web du Guichet 
              emplois</a> du gouvernement du Canada.
            </p>
            <p>
              La médiane est utilisée pour le salaire horaire d'une profession. Le salaire médian est préféré au salaire moyen car il est moins sensible aux valeurs extrêmes et 
              plus représentatif du salaire type du travailleur.
            </p>
            <p>
              Les professions sont classées à l'aide du système de Classification nationale des professions au niveau des codes à quatre chiffres.
            </p>
            <p>
              Les données d'emplacement sont présentées par région économique, une variante du système de Classification géographique type, normalisées créé par Statistique 
              Canada en tant qu'unité géographique standard pour l'analyse de l'activité économique dans 76 régions du Canada. Dans notre widget, chaque emplacement est lié 
              à sa région économique.
            </p>
            <h3 class="is-size-5">Quelles sources de données sont utilisées?</h3>
            <p>
              Les salaires sont déterminés à l'aide d'une méthodologie conjointe d'<abbr title="Emploi et Développement social Canada">EDSC</abbr> et de Statistique Canada. 
              <abbr title="Emploi et Développement social Canada">EDSC</abbr> consulte d'autres intervenants au cours du processus de validation, comme les gouvernements 
              provinciaux et territoriaux, d'autres ministères fédéraux et des organismes externes.
            </p>
            <p>
              En tant que source principale du jeu de données, <abbr title="Emploi et Développement social Canada">EDSC</abbr> utilise l'Enquête sur la population active 
              de Statistique Canada :
            </p>
            <ul>
              <li>la source de données sur les salaires par groupe professionnel la plus inclusive, opportune et impartiale;</li>
              <li>cette enquête est menée auprès d'un échantillon de répondants;</li>
              <li>les données peuvent être supprimées pour des raisons de confidentialité ou de qualité des données.</li>
            </ul>
            <p>
              Lorsque les données de l'Enquête sur la population active ne sont pas disponibles, d'autres sources sont envisagées, notamment :
            </p>
            <ul>
              <li>les données du programme d'<abbr title="Emploi et Développement social Canada">EDSC</abbr>, comme les données d'enquête sur le programme d'assurance-emploi;</li>
              <li>le recensement;</li>
              <li>les enquêtes provinciales et territoriales et les données administratives;</li>
              <li>autres données administratives des organisations.</li>
            </ul>
            <p>
              Pour le processus complet suivi par <abbr title="Emploi et Développement social Canada">EDSC</abbr>, veuillez consulter leur 
              <a href="https://www.guichetemplois.gc.ca/analyse-tendances/recherche-salaires/methodologie-salaires" target="_blank">méthodologie des salaires</a>.
            </p>
            <h3 class="is-size-5">Avez-vous manipulé le jeu de données d'origine?</h3>
            <p>
              Nous avons supprimé du jeu de données les salaires qui étaient présentés comme un salaire annuel au lieu d'un salaire horaire. Cependant, ces données peuvent 
              être trouvées à partir de la source d'origine.
            </p>
            <h3 class="is-size-5">Pourquoi n'y a-t-il pas de données disponibles pour certaines combinaisons de profession et d'emplacement?</h3>
            <p>
              Il n'est pas toujours possible de déterminer les salaires des professions pour toutes les régions économiques en raison des limites des données (suppression 
              des données pour des raisons de faible qualité et de confidentialité). Lorsque c'est le cas, nous afficherons le salaire minimum de la province ou du territoire. 
              Lorsque vous comparez des emplacements ou des industries, ces valeurs non disponibles afficheront comme étant sans objet (s.o.) et sans le salaire minimum.
            </p>
            <h3 class="is-size-5">Comment pouvez-vous extraire des données sur les professions en recherchant une industrie?</h3>
            <p>
              Nous avons effectué une analyse approfondie pour élaborer une cartographie des professions par industrie. Grâce à des tableaux de concordance, 
              nous pouvons relier les données sur les salaires par profession à leurs industries connexes.
            </p>
            <h3 class="is-size-5">Quel jeu de données est utilisés par le widget?</h3>
            <p>
              Notre widget utilise le jeu de données sur les salaires d'<abbr title="Emploi et Développement social Canada">EDSC</abbr> 2019, qui peut être téléchargé à partir 
              du <a href="https://ouvert.canada.ca/data/fr/dataset/adad580f-76b0-4502-bd05-20c125de9116" target="_blank">site Web de données ouvertes</a> du gouvernement du Canada.
            </p>
            <h3 class="is-size-5">Combien de temps le widget est-il mis à jour suite à la publication d'une nouvelle version des données sur les salaires?</h3>
            <p>
              Notre objectif est de mettre à jour les données dans les 3 mois suivant la nouvelle version du nouveau jeu de données. Ce jeu de données est produit chaque année 
              et publié à la fin de l'automne.
            </p>
            <h3 class="is-size-5">Énoncé d'attribution</h3>
            <p> 
              Contient de l'information visée par la <a href="https://ouvert.canada.ca/fr/licence-du-gouvernement-ouvert-canada" target="_blank">Licence du gouvernement ouvert - Canada</a>
            </p>`,
          print_text: "Imprimer",
          close_text: "Fermer"
        }
      }
    }
  },
  // end i18n
  props: ['lang'],
  mounted: function () {
    this.$i18n.locale = this.toggleLang;
  },
  computed: {
    toggleLang: function () {
      return this.lang;
    }
  },
  // end computed
  methods: {
    print: function () {
      const d = new Printd();
      d.print(this.$refs.PrintBody);
    }
  } // end methods

};

/* script */
const __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('section', [_c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "id": "wage"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    ref: "PrintBody",
    staticClass: "modal-card-body footerSourceModal",
    attrs: {
      "id": "printBody"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('faq.faq_wage'))
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('faq.faq_general'))
    }
  })]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot footerSourceModal-foot"
  }, [_c('b-button', {
    staticClass: "button",
    on: {
      "click": function ($event) {
        return _vm.print();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('faq.print_text')))]), _vm._v(" "), _c('b-button', {
    staticClass: "button",
    on: {
      "click": function ($event) {
        return _vm.$parent.close();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('faq.close_text')))])], 1)])]);
};

var __vue_staticRenderFns__$3 = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('header', {
    staticClass: "modal-card-head footerSourceModal-head"
  }, [_c('p', {
    staticClass: "modal-card-title footerSourceModal-title"
  }, [_vm._v("FAQ")])]);
}];
/* style */

const __vue_inject_styles__$3 = undefined;
/* scoped */

const __vue_scope_id__$3 = undefined;
/* module identifier */

const __vue_module_identifier__$3 = undefined;
/* functional template */

const __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

//
Vue.use(Modal);
var script$4 = {
  props: ['lang', 'faq'],
  computed: {
    toggleLang: function () {
      return this.lang;
    }
  },
  // end computed
  methods: {
    openModal: function () {
      this.$buefy.modal.open({
        props: {
          'lang': this.toggleLang
        },
        parent: this,
        component: this.faq == "fp" ? __vue_component__$1 : this.faq == "pop" ? __vue_component__$2 : this.faq == "wage" ? __vue_component__$3 : __vue_component__,
        hasModalCard: true
      });
    }
  } // end methods

};

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('section', [_c('a', {
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function ($event) {
        return _vm.openModal();
      },
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.openModal();
      }
    }
  }, [_vm._v("FAQ")])]);
};

var __vue_staticRenderFns__$4 = [];
/* style */

const __vue_inject_styles__$4 = function (inject) {
  if (!inject) return;
  inject("data-v-b59c439c_0", {
    source: ".footerSourceModal h3{margin:1em 0!important}.footerSourceModal p{margin-bottom:1em!important}.footerSourceModal ul{list-style:inside!important;list-style-type:disc!important;padding-bottom:10px!important}.footerSourceModal a{color:#3273dc!important}.footerSourceModal-head{padding-top:5px!important;padding-bottom:5px!important}.footerSourceModal-title{padding-bottom:0!important;margin-bottom:0!important}.footerSourceModal-foot{padding-top:5px!important;padding-bottom:5px!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$4 = undefined;
/* module identifier */

const __vue_module_identifier__$4 = undefined;
/* functional template */

const __vue_is_functional_template__$4 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, createInjector, undefined, undefined);

//
library.add(faMinusSquare, faPlusSquare);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(Collapse);
var script$5 = {
  props: ['lang', 'summary', 'source', 'summaryContent', 'faq'],
  components: {
    'faq-link': __vue_component__$4
  },
  data: function () {
    return {
      FooterisOpen: false
    };
  },
  // data
  computed: {
    toggleLang: function () {
      return this.lang;
    }
  },
  // end computed
  methods: {
    simulateClick: function () {
      this.FooterisOpen = !this.FooterisOpen;
    }
  } //methods

}; // default

/* script */
const __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('b-collapse', {
    attrs: {
      "open": _vm.FooterisOpen
    },
    on: {
      "update:open": function ($event) {
        _vm.FooterisOpen = $event;
      }
    }
  }, [_c('div', {
    staticClass: "card-footer-header",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('div', {
    staticClass: "card-footer-item footerSource"
  }, [_c('span', {
    staticClass: "flink",
    domProps: {
      "innerHTML": _vm._s(_vm.source)
    }
  }), _vm._v(" "), _vm.summary ? _c('span', {
    staticClass: "flink"
  }, [_c('a', {
    attrs: {
      "tabindex": "0"
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.simulateClick();
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "fa-sm",
    attrs: {
      "icon": ['fas', _vm.FooterisOpen ? 'minus-square' : 'plus-square'],
      "type": "is-info"
    }
  }), _vm._v("Note")], 1)]) : _vm._e(), _vm._v(" "), _vm.faq != null ? _c('span', {
    staticClass: "flink"
  }, [_c('faq-link', {
    attrs: {
      "lang": _vm.toggleLang,
      "faq": _vm.faq
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _vm.summary ? _c('div', {
    staticClass: "card-footer-content"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.summaryContent)
    }
  })]) : _vm._e()]);
};

var __vue_staticRenderFns__$5 = [];
/* style */

const __vue_inject_styles__$5 = function (inject) {
  if (!inject) return;
  inject("data-v-5c6aa67b_0", {
    source: ".footerSource a{color:#3273dc!important}.fa-sm{font-size:.875em}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$5 = undefined;
/* module identifier */

const __vue_module_identifier__$5 = undefined;
/* functional template */

const __vue_is_functional_template__$5 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, createInjector, undefined, undefined);

//
Vue.use(VueI18nFooter); // Create VueI18n instance with options

const i18n$4 = new VueI18nFooter({
  locale: 'en'
});
var script$6 = {
  name: "OpenServicesFooterComponent",
  // vue component name
  i18n: {
    locale: "en",
    messages: {
      en: {
        source: {
          sgc_source: 'Source:&nbsp;<a href="http://www23.statcan.gc.ca/imdb/p3VD.pl?Function=getVD&TVD=314300" target="_blank">Standard Geographical Classification (SGC) 2016, Statistics Canada</a>',
          sgc_source_mobile: '<a href="http://www23.statcan.gc.ca/imdb/p3VD.pl?Function=getVD&TVD=314300" target="_blank">Data Source</a>',
          sgc_summary_content: '',
          naics_source: 'Source:&nbsp;<a href="http://www23.statcan.gc.ca/imdb/p3VD.pl?Function=getVD&TVD=380372" target="_blank">North American Industry Classification System (NAICS) Canada 2017, Statistics Canada</a>',
          naics_source_mobile: '<a href="http://www23.statcan.gc.ca/imdb/p3VD.pl?Function=getVD&TVD=380372" target="_blank">Data Source</a>',
          naics_summary_content: '',
          wage_source: 'Source:&nbsp;<a href="https://open.canada.ca/data/en/dataset/adad580f-76b0-4502-bd05-20c125de9116" target="_blank">Wages Dataset, Employment and Social Development Canada (ESDC), 2019</a>',
          wage_source_mobile: '<a href="https://open.canada.ca/data/en/dataset/adad580f-76b0-4502-bd05-20c125de9116" target="_blank">Data Source</a>',
          wage_summary_content: 'Some combinations of industry and location may not have data due to data limitations. No calculations have been made. Find more information in our FAQ.',
          income_source: 'Source:&nbsp;<a href="https://www12.statcan.gc.ca/census-recensement/2016/dp-pd/prof/index.cfm?Lang=E" target="_blank">Census Profile, 2016 Census, Statistics Canada</a>',
          income_source_mobile: '<a href="https://www12.statcan.gc.ca/census-recensement/2016/dp-pd/prof/index.cfm?Lang=E" target="_blank">Data Source</a>',
          income_summary_content: '',
          fp_source: 'Source:&nbsp;<a href="http://open.canada.ca/data/en/dataset/f559526c-40f9-4c5d-bced-0f7a41f278b9" target="_blank">Financial Performance Data, ISED, 2015</a>',
          fp_source_mobile: '<a href="http://open.canada.ca/data/en/dataset/f559526c-40f9-4c5d-bced-0f7a41f278b9" target="_blank">Data Source</a>',
          fp_summary_content: 'No calculations have been made. See our FAQ page for more information on the original dataset.',
          pop_source: 'Source:&nbsp;<a href="http://www12.statcan.gc.ca/census-recensement/2016/dp-pd/dt-td/Rp-eng.cfm?TABID=2&amp;LANG=E&amp;A=R&amp;APATH=3&amp;DETAIL=0&amp;DIM=0&amp;FL=A&amp;FREE=0&amp;GC=01&amp;GL=-1&amp;GID=1159582&amp;GK=1&amp;GRP=1&amp;O=D&amp;PID=109526&amp;PRID=10&amp;PTYPE=109445&amp;S=0&amp;SHOWALL=0&amp;SUB=0&amp;Temporal=2016&amp;THEME=115&amp;VID=0&amp;VNAMEE=&amp;VNAMEF=&amp;D1=0&amp;D2=0&amp;D3=0&amp;D4=0&amp;D5=0&amp;D6=0" target="_blank">Census, Statistics Canada, 2016</a>',
          pop_source_mobile: '<a href="http://www12.statcan.gc.ca/census-recensement/2016/dp-pd/dt-td/Rp-eng.cfm?TABID=2&amp;LANG=E&amp;A=R&amp;APATH=3&amp;DETAIL=0&amp;DIM=0&amp;FL=A&amp;FREE=0&amp;GC=01&amp;GL=-1&amp;GID=1159582&amp;GK=1&amp;GRP=1&amp;O=D&amp;PID=109526&amp;PRID=10&amp;PTYPE=109445&amp;S=0&amp;SHOWALL=0&amp;SUB=0&amp;Temporal=2016&amp;THEME=115&amp;VID=0&amp;VNAMEE=&amp;VNAMEF=&amp;D1=0&amp;D2=0&amp;D3=0&amp;D4=0&amp;D5=0&amp;D6=0" target="_blank">Data Source</a>',
          pop_summary_content: '',
          tenders_source: 'Source:&nbsp;<a href="http://buyandsell.gc.ca" target="_blank">Buyandsell.gc.ca, Public Works and Government Services Canada, 2018</a>',
          tenders_source_mobile: '<a href="http://buyandsell.gc.ca" target="_blank">Buyandsell.gc.ca, Public Works and Government Services Canada, 2018</a>',
          tenders_summary_content: 'Have questions about Government Tenders? Let us help! Call the BuyandSell InfoLine at 1-800-811-1148. We are here to help you do business with the Government of Canada.',
          permit_source: 'Source:&nbsp;<a href="https://www.bizpal.ca/" target="_blank">BizPaL, ISED, 2018</a>',
          permit_source_mobile: '<a href="https://www.bizpal.ca/" target="_blank">Data Source</a>',
          permit_summary_content: 'Information comes from many different federal departments and agencies, as well as external sources and other levels of government. Every effort is made to ensure the accuracy, currency and reliability of the content.'
        }
      },
      fr: {
        source: {
          sgc_source: 'Source&nbsp;:&nbsp;<a href="http://www23.statcan.gc.ca/imdb/p3VD_f.pl?Function=getVD&TVD=314300" target="_blank">Classification géographique type (CGT) 2016, Statistique Canada</a>',
          sgc_source_mobile: '<a href="http://www23.statcan.gc.ca/imdb/p3VD_f.pl?Function=getVD&TVD=314300" target="_blank">Source de données</a>',
          sgc_summary_content: '',
          naics_source: 'Source&nbsp;:&nbsp;<a href="http://www23.statcan.gc.ca/imdb/p3VD_f.pl?Function=getVD&TVD=380372" target="_blank">Système de classification des industries de l\'Amérique du Nord (SCIAN) Canada 2017, Statistique Canada</a>',
          naics_source_mobile: '<a href="http://www23.statcan.gc.ca/imdb/p3VD_f.pl?Function=getVD&TVD=380372" target="_blank">Source de données</a>',
          naics_summary_content: '',
          wage_source: 'Source&nbsp;:&nbsp;<a href="https://ouvert.canada.ca/data/fr/dataset/adad580f-76b0-4502-bd05-20c125de9116" target="_blank">Jeu de données sur les salaires, Emploi et Développement social Canada (EDSC), 2019</a>',
          wage_source_mobile: '<a href="https://ouvert.canada.ca/data/fr/dataset/adad580f-76b0-4502-bd05-20c125de9116" target="_blank">Source de données</a>',
          wage_summary_content: `Certaines combinaisons d'industrie et d'emplacement peuvent ne pas avoir de données en raison de limites des données. Aucun calcul n'a été effectué. Obtenez plus de renseignement dans la FAQ.`,
          income_source: 'Source&nbsp;:&nbsp;<a href="https://www12.statcan.gc.ca/census-recensement/2016/dp-pd/prof/index.cfm?Lang=F" target="_blank">Profil du recensement, Recensement de 2016, Statistique Canada</a>',
          income_source_mobile: '<a href="https://www12.statcan.gc.ca/census-recensement/2016/dp-pd/prof/index.cfm?Lang=F" target="_blank">Source de données</a>',
          income_summary_content: '',
          fp_source: 'Source :&nbsp;<a href="https://ouvert.canada.ca/data/fr/dataset/f559526c-40f9-4c5d-bced-0f7a41f278b9" target="_blank">Données sur la performance financière, ISDE, 2015</a>',
          fp_source_mobile: '<a href="https://ouvert.canada.ca/data/fr/dataset/f559526c-40f9-4c5d-bced-0f7a41f278b9" target="_blank">Source de données</a>',
          fp_summary_content: `Aucune calculation n'a été effectué. Voir notre page FAQ pour plus d'information sur l'ensemble de donnée original.`,
          pop_source: 'Source&nbsp;:&nbsp;<a href="https://www12.statcan.gc.ca/census-recensement/2016/dp-pd/dt-td/Rp-fra.cfm?TABID=2&LANG=F&A=R&APATH=3&DETAIL=0&DIM=0&FL=A&FREE=0&GC=01&GL=-1&GID=1159582&GK=1&GRP=1&O=D&PID=109526&PRID=10&PTYPE=109445&S=0&SHOWALL=0&SUB=0&Temporal=2016&THEME=115&VID=0&VNAMEE=&VNAMEF=&D1=0&D2=0&D3=0&D4=0&D5=0&D6=0" target="_blank">Recensement, Statistique Canada, 2016</a>',
          pop_source_mobile: '<a href="https://www12.statcan.gc.ca/census-recensement/2016/dp-pd/dt-td/Rp-fra.cfm?TABID=2&LANG=F&A=R&APATH=3&DETAIL=0&DIM=0&FL=A&FREE=0&GC=01&GL=-1&GID=1159582&GK=1&GRP=1&O=D&PID=109526&PRID=10&PTYPE=109445&S=0&SHOWALL=0&SUB=0&Temporal=2016&THEME=115&VID=0&VNAMEE=&VNAMEF=&D1=0&D2=0&D3=0&D4=0&D5=0&D6=0" target="_blank">Source de données</a>',
          pop_summary_content: '',
          tenders_source: 'Source&nbsp;:&nbsp;<a href="https://achatsetventes.gc.ca/" target="_blank">Achatsetventes.gc.ca, Travaux publics et Services gouvernementaux Canada, 2018</a>',
          tenders_source_mobile: '<a href="https://achatsetventes.gc.ca/" target="_blank">Source de données</a>',
          tenders_summary_content: 'Vous avez des questions? Laissez-nous vous aider! Appelez la LigneInfo au 1-800-811-1148. Nous sommes là pour vous aider à faire affaire avec le gouvernement du Canada.',
          permit_source: 'Source&nbsp;:&nbsp;<a href="https://www.perle-bizpal.ca/fr/" target="_blank">PerLE, ISDE, 2018</a>',
          permit_source_mobile: '<a href="https://www.perle-bizpal.ca/fr/" target="_blank">Source de données</a>',
          permit_summary_content: `L'information provient de plusieurs ministères et agences du gouvernement fédéral, ainsi que des sources externes et autres niveaux de gouvernement. Tous les efforts sont fait pour assurer l'exactitude, l'actualité et la fiabilité du contenu.`
        }
      }
    }
  },
  // end i18n
  props: {
    lang: {
      type: String,
      default: "en"
    },
    widget: {
      type: String
    }
  },
  // end props
  data: function () {
    return {
      faq: "",
      //sources
      source: "",
      summary: false,
      //set to true to show if there is a summary entered in summaryContent
      summaryContent: ""
    };
  },
  // end data
  mounted: function () {
    let screenWidth = window.innerWidth;
    let isMobile = screenWidth < 768 ? true : false;
    this.$i18n.locale = this.toggleLang;

    if (this.widget == "sgc") {
      this.source = isMobile ? this.$t('source.sgc_source_mobile') : this.$t('source.sgc_source');
      this.summaryContent = this.$t('source.sgc_summary_content');
      this.summary = false;
      this.faq = null; //no FAQ
    } else if (this.widget == "naics") {
      this.source = isMobile ? this.$t('source.naics_source_mobile') : this.$t('source.naics_source');
      this.summaryContent = this.$t('source.naics_summary_content');
      this.summary = false;
      this.faq = "general";
    } else if (this.widget == "wage") {
      this.source = isMobile ? this.$t('source.wage_source_mobile') : this.$t('source.wage_source');
      this.summaryContent = this.$t('source.wage_summary_content');
      this.summary = true;
      this.faq = "wage";
    } else if (this.widget == "income") {
      this.source = isMobile ? this.$t('source.income_source_mobile') : this.$t('source.income_source');
      this.summaryContent = this.$t('source.income_summary_content');
      this.summary = false;
      this.faq = "general";
    } else if (this.widget == "pop") {
      this.source = isMobile ? this.$t('source.pop_source_mobile') : this.$t('source.pop_source');
      this.summaryContent = this.$t('source.pop_summary_content');
      this.summary = false;
      this.faq = "pop";
    } else if (this.widget == "fp") {
      this.source = isMobile ? this.$t('source.fp_source_mobile') : this.$t('source.fp_source');
      this.summaryContent = this.$t('source.fp_summary_content');
      this.summary = true;
      this.faq = "fp";
    } else if (this.widget == "permit") {
      this.source = isMobile ? this.$t('source.permit_source_mobile') : this.$t('source.permit_source');
      this.summaryContent = this.$t('source.permit_summary_content');
      this.summary = true;
      this.faq = "general";
    } else if (this.widget == "tenders") {
      this.source = isMobile ? this.$t('source.tenders_source_mobile') : this.$t('source.tenders_source');
      this.summaryContent = this.$t('source.tenders_summary_content');
      this.summary = true;
      this.faq = "general";
    }
  },
  // end mounted
  components: {
    "source-footer": __vue_component__$5
  },
  // end component
  computed: {
    toggleLang: function () {
      return this.lang;
    }
  } // end computed

}; // end export

/* script */
const __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('footer', {
    staticClass: "basefooter"
  }, [_c('source-footer', {
    attrs: {
      "lang": _vm.toggleLang,
      "source": _vm.source,
      "summary": _vm.summary,
      "summaryContent": _vm.summaryContent,
      "faq": _vm.faq
    }
  })], 1);
};

var __vue_staticRenderFns__$6 = [];
/* style */

const __vue_inject_styles__$6 = function (inject) {
  if (!inject) return;
  inject("data-v-fea73bac_0", {
    source: ".basefooter .card-footer-header{background:#fafafa}.basefooter .card-footer-header .columns{margin:0}.basefooter .card-footer-header .column{border:none!important}.basefooter .card-footer-item{background:#f8f8f8;justify-content:left!important;padding-left:1.5em;padding-right:.75em;border:none!important;opacity:.8}.basefooter .card-footer-item span.flink{display:inline-block;margin-right:1.6em}.basefooter .card-footer-item a{text-decoration:underline}.basefooter .card-footer-content{background:#fafafa!important;padding-left:1.5em!important;padding-right:1.5em!important;padding-top:0!important;padding-bottom:1.5em!important}.basefooter .collapse{display:block!important}.basefooter .footer{display:block!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$6 = undefined;
/* module identifier */

const __vue_module_identifier__$6 = undefined;
/* functional template */

const __vue_is_functional_template__$6 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, createInjector, undefined, undefined);

// Import vue component

const install = function installOpenServicesFooterComponent(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('OpenServicesFooterComponent', __vue_component__$6);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__$6.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__$6;
